import FormattedTime from 'components/ui/FormattedTime'
import LoadBoxWrapper from 'components/ui/LoadBoxWrapper'
import { useList } from 'hooks/listHooks'
import React from 'react'
import phoneViewsSchema from 'schemes/phoneViewsSchema'
import TableList from '../TableList'

const definitions = {
    phone_view_id: { name: '#' },
    created: { name: 'time' },
}

function renderRow(id, entities) {
    const { phoneViews } = entities
    const phoneView = phoneViews[id]

    return {
        cols: Object.keys(definitions).map((key) => {
            const value = phoneView[key]

            switch (key) {
                case 'phone_view_id':
                    return <small>{value}</small>
                case 'created':
                    return <FormattedTime date={value || ''} />
                default:
                    return value
            }
        }),
    }
}

const PhoneViewsList = ({ providerId, filterId = 'all' }) => {
    const {
        filter = {},
        currentPage,
        ...rest
    } = useList(
        filterId,
        {
            url: 'phone-views/get-list',
            schema: phoneViewsSchema,
            reducerKey: 'phoneViews',
        },
        {
            providerId,
            pageSize: 10,
        },
    )

    const rows = {}
    currentPage.forEach((id) => {
        rows[id] = renderRow(id, rest.entities)
    })

    return (
        <LoadBoxWrapper isLoading={rest.isFetching}>
            <TableList
                {...rest}
                filter={filter}
                rows={rows}
                definitions={definitions}
                addListFeatures
                hideSearch
                hideExport
                hideOrder
            />
        </LoadBoxWrapper>
    )
}

export default PhoneViewsList
